export function getCookie(name) {
	const value = "; " + document.cookie;
	const parts = value.split("; " + name + "=");
	if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
}

export function setCookie( name, val, hours, domain)
{
	let now = new Date();
	let time = now.getTime();
	time += hours*3600 * 1000;
	now.setTime(time);

    let string = name+'=' + val + '; expires=' + now.toUTCString() + ';path=/';

    if(typeof domain !== 'undefined')
        string += ';domain='+domain;

	document.cookie = string;
}

export function setMtmAuthCookie(authData){
	const rootHost = window.location.hostname.split('.').reverse().splice(0,2).reverse().join('.');
	if(authData === null)
	{
		document.cookie = 'mtm_auth=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain='+rootHost;
	}
	else
	{
		let now = new Date();
		let time = now.getTime();
		time += 30*24*3600 * 1000;
		now.setTime(time);

		document.cookie = 'mtm_auth=' + JSON.stringify(authData) + '; expires=' + now.toUTCString() + ';path=/;domain='+rootHost;
	}
}

export function deleteCookie(name)
{
	document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

export function setSettingsCookie(name, val) {
	let value = '';
	const cookie = getCookie('mtm_settings');
	if(typeof(cookie) === "undefined" ){
		let temp = {};
		temp[name] = val;
		dataholder.mtm_settings = temp;
		value = JSON.stringify(temp);
	}
	else
	{
		dataholder.mtm_settings = JSON.parse(cookie);
		if(val === "none" || val === false){
			delete dataholder.mtm_settings[name];
		}else{
			dataholder.mtm_settings[name] = val;
		}

		value = JSON.stringify(dataholder.mtm_settings);
	}
	setCookie('mtm_settings', value, 2);
}



export function getFavoriteCookie()
{
	return (siteID === "2") ? getCookie('favorithauser') : getCookie('favorithuse') ;
}


